var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ModalContainer",
    {
      attrs: {
        size: _vm.size,
        modalId: _vm.modalId,
        contentClass: _vm.contentClass,
      },
      on: { close: _vm.onClose },
    },
    [
      _vm._t("default", function () {
        return [
          _vm._t("header", function () {
            return [
              _vm.renderTitle
                ? _c(
                    "ModalHeader",
                    {
                      attrs: {
                        title: _vm.title,
                        showCustomTitle: _vm.showCustomTitle,
                        fullWidth: _vm.showCustomTitle,
                        styles: _vm.addClass,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex",
                          class: _vm.modalHeaderSlotClasses,
                        },
                        [
                          _vm._t("titleLine"),
                          _c(
                            "button",
                            {
                              staticClass:
                                "ml-2 text-gray-400 hover:text-gray-500 focus:text-gray-500 focus:outline-none",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("close")
                                },
                                mouseover: function ($event) {
                                  _vm.isHovered = true
                                },
                                mouseout: function ($event) {
                                  _vm.isHovered = false
                                },
                              },
                            },
                            [
                              !_vm.isHovered
                                ? _c("CrossIcon", { staticClass: "close-icon" })
                                : _vm._e(),
                              _vm.isHovered
                                ? _c("CrossIconHover", {
                                    staticClass: "close-icon",
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          }),
          _c(
            "div",
            { staticClass: "px-2" },
            [
              _vm._t("content", function () {
                return [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.$emit("submit")
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex flex-col",
                          class: _vm.customAlignment,
                        },
                        [_vm._t("form")],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [_vm._t("actions")],
                        2
                      ),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }